<div class="card yearly-view">
  <div class="card-header pb-0">
    <h3>Създадени Сигнали<span class="badge badge-primary">50/100</span></h3>
    <h5 class="mb-0">Monday</h5>
  </div>
  <div class="card-body p-0">
    <div class="yearly-view" id="yearly-view">
      <ng-container *ngIf="isLoading">
        <app-loader text="Зареждане Моля изчакайте..."></app-loader>
      </ng-container>
      <ng-container *ngIf="!isLoading">
        <apx-chart [series]="totalRegisteredSignalsByYear.series"
                   [chart]="totalRegisteredSignalsByYear.chart"
                   [stroke]="totalRegisteredSignalsByYear.stroke"
                   [annotations]="totalRegisteredSignalsByYear.annotations"
                   [colors]="totalRegisteredSignalsByYear.colors"
                   [yaxis]="totalRegisteredSignalsByYear.yaxis"
                   [xaxis]="totalRegisteredSignalsByYear.xaxis"
                   [legend]="totalRegisteredSignalsByYear.legend"
                   [tooltip]="totalRegisteredSignalsByYear.tooltip"
                   [dataLabels]="totalRegisteredSignalsByYear.dataLabels"
                   [grid]="totalRegisteredSignalsByYear.grid"
                   [responsive]="totalRegisteredSignalsByYear.responsive">
        </apx-chart>
      </ng-container>
    </div>
  </div>
</div>
